import { useMemo } from 'react'

import { LineHeightOutlined } from '@ant-design/icons'
import { Dropdown } from 'antd'

import { getFirstScrolledParent } from '@eastcoal/common/utils/dom'

import { useLineHeight } from '../../hooks/useLineHeight'
import { DropdownButton } from '../../ui/DropdownButton'

export const LineHeightDropdown = () => {
  const { lineHeightList, lineHeight, setLineHeight } = useLineHeight()

  const items = useMemo(
    () =>
      lineHeightList.map(({ label }) => ({
        label,
        key: label
      })),
    [lineHeightList]
  )
  const selectedKeys = useMemo(() => {
    const selectedItem = lineHeightList.find(item => item.value === lineHeight)
    return selectedItem ? [selectedItem.label] : undefined
  }, [lineHeightList, lineHeight])

  return (
    <Dropdown
      getPopupContainer={triggerNode => getFirstScrolledParent(triggerNode)}
      trigger={['click']}
      menu={{
        items,
        selectedKeys,
        onClick({ key }) {
          const selectedItem = lineHeightList.find(item => item.label === key)
          if (selectedItem) {
            setLineHeight(selectedItem.value)
          }
        }
      }}
    >
      <DropdownButton tooltip='行高'>
        <LineHeightOutlined />
      </DropdownButton>
    </Dropdown>
  )
}
